const message = {
  state: {
    ChatRelatedTo:0,

    //----------- Course Related Chats -----------
    UserThreads:[],
    ClientThreads:[],
    GroupThreads:[],
    //----------- Course Related Chats -----------

    
    //----------- Class Related Chats -----------
    UserThreadsClass:[],
    ClientThreadsClass:[],
    GroupThreadsClass:[],
    //----------- Class Related Chats -----------

    
    //----------- General Related Chats -----------
    UserThreadsGeneral:[],
    ClientThreadsGeneral:[],
    GroupThreadsGeneral:[],
    //----------- General Related Chats -----------

    User_Active_Thread:null,
    Client_Active_Thread:null,
    Group_Active_Thread:null,
    Active_Single_Thread_Details:'',
    ActiveTab:0,
    chats: [
      {
        message:'Hello ',
        message_time:1607343757,
        user:{
          name:'Paradox Joe',
          user_id:1,
          status:'offline',
          user_pic:'https://freepngimg.com/thumb/iron_man/1-2-iron-man-picture.png'
        }
      },
      {
        message:'How are You? ',
        message_time:1607343757,
        user:{
          name:'Paradox Joe',
          user_id:1,
          status:'offline',
          user_pic:'https://freepngimg.com/thumb/iron_man/1-2-iron-man-picture.png'
        }
      },
      {
        message:'I am Fine ',
        message_time:1607343757,
        user:{
          name:'Paradox Joe',
          user_id:1,
          status:'offline',
          user_pic:'https://freepngimg.com/thumb/iron_man/1-2-iron-man-picture.png'
        }
      },
      {
        message:'Hello ',
        message_time:1607430157,
        user:{
          name:'Paradox Joe',
          user_id:1,
          status:'offline',
          user_pic:'https://freepngimg.com/thumb/iron_man/1-2-iron-man-picture.png'
        }
      },
      {
        message:'How are You? ',
        message_time:1607430157,
        user:{
          name:'Paradox Joe',
          user_id:1,
          status:'offline',
          user_pic:'https://freepngimg.com/thumb/iron_man/1-2-iron-man-picture.png'
        }
      },
      {
        message:'I am Fine ',
        message_time:1607430157,
        user:{
          name:'Paradox Joe',
          user_id:1,
          status:'offline',
          user_pic:'https://freepngimg.com/thumb/iron_man/1-2-iron-man-picture.png'
        }
      },
      {
        message:'Whats about you?',
        message_time:1607430157,
        user:{
          name:'Paradox Joe',
          user_id:55,
          status:'offline',
          user_pic:'https://freepngimg.com/thumb/iron_man/1-2-iron-man-picture.png'
        }
      },
      {
        message:'We can use the v-for directive to render a list of items based on an array. The v-for directive requires a special syntax in the form of item in items, where items is the source data array and item is an alias for the array element being iterated on:',
        message_time:1607430157,
        user:{
          name:'Paradox Joe',
          user_id:1,
          status:'offline',
          user_pic:'https://freepngimg.com/thumb/iron_man/1-2-iron-man-picture.png'
        }
      }
    ]
  },
  mutations: {
    SET_CHAT_RELATED_TO_MUTATION: (state, payload) => {
      state.ChatRelatedTo = payload
    },
    

    //----------- Course Related Chats -----------
    SET_USERS_THREAD_MUTATION: (state, payload) => {
      state.UserThreads = payload
    },
    SET_CLIENT_THREAD_MUTATION: (state, payload) => {
      state.ClientThreads = payload
    },
    SET_GROUP_THREAD_MUTATION: (state, payload) => {
      state.GroupThreads = payload
    },
    //----------- Course Related Chats -----------


    //----------- Class Related Chats -----------
    SET_USERS_THREAD_CLASS_MUTATION: (state, payload) => {
      state.UserThreadsClass = payload
    },

    SET_CLIENT_THREAD_CLASS_MUTATION: (state, payload) => {
      state.ClientThreadsClass = payload
    },

    SET_GROUP_THREAD_CLASS_MUTATION: (state, payload) => {
      state.GroupThreadsClass = payload
    },
    //----------- Class Related Chats -----------

    
    //----------- General Related Chats -----------
    SET_USERS_THREAD_GENERAL_MUTATION: (state, payload) => {
      state.UserThreadsGeneral = payload
    },
    SET_CLIENT_THREAD_GENERAL_MUTATION: (state, payload) => {
      state.ClientThreadsGeneral = payload
    },
    SET_GROUP_THREAD_GENERAL_MUTATION: (state, payload) => {
      state.GroupThreadsGeneral = payload
    },
    //----------- General Related Chats -----------


    SET_USER_ACTIVE_THREAD_MUTATION:(state, payload) => {
      state.User_Active_Thread = payload
    },
    SET_CLIENT_ACTIVE_THREAD_MUTATION:(state, payload) => {
      state.Client_Active_Thread = payload
    },
    SET_GROUP_ACTIVE_THREAD_MUTATION:(state, payload) => {
      state.Group_Active_Thread = payload
    },
    SET_ACTIVE_SINGLE_THREAD_DETAILS_MUTATION:(state, payload) => {
      state.Active_Single_Thread_Details = payload
    },
    
    SET_ACTIVE_TAB_MUTATION: (state, payload) => {
      state.ActiveTab = payload
    },
    SET_CHATS_MUTATION: (state, payload) => {
      state.chats = payload
    }
  },
  actions: {
    SET_CHAT_RELATED_TO: ({ commit }, payload) => {
      commit('SET_CHAT_RELATED_TO_MUTATION', payload)
    },


    //----------- Course Related Chats -----------
    SET_USERS_THREADS: ({ commit }, payload) => {
      commit('SET_USERS_THREAD_MUTATION', payload)
    },
    SET_CLIENT_THREADS: ({ commit }, payload) => {
      commit('SET_CLIENT_THREAD_MUTATION', payload)
    },
    SET_GROUP_THREADS: ({ commit }, payload) => {
      commit('SET_GROUP_THREAD_MUTATION', payload)
    },
    //----------- Course Related Chats -----------


    //----------- Class Related Chats -----------
    SET_USERS_THREADS_CLASS: ({ commit }, payload) => {
      commit('SET_USERS_THREAD_CLASS_MUTATION', payload)
    },
    SET_CLIENT_THREADS_CLASS: ({ commit }, payload) => {
      commit('SET_CLIENT_THREAD_CLASS_MUTATION', payload)
    },
    SET_GROUP_THREADS_CLASS: ({ commit }, payload) => {
      commit('SET_GROUP_THREAD_CLASS_MUTATION', payload)
    },
    //----------- Class Related Chats -----------
   
    
    //----------- General Related Chats -----------
    SET_USERS_THREADS_GENERAL: ({ commit }, payload) => {
      commit('SET_USERS_THREAD_GENERAL_MUTATION', payload)
    },
    SET_CLIENT_THREADS_GENERAL: ({ commit }, payload) => {
      commit('SET_CLIENT_THREAD_GENERAL_MUTATION', payload)
    },
    SET_GROUP_THREADS_GENERAL: ({ commit }, payload) => {
      commit('SET_GROUP_THREAD_GENERAL_MUTATION', payload)
    },
    //----------- General Related Chats -----------


    SET_USER_ACTIVE_THREAD:({ commit }, payload) => {
      commit('SET_USER_ACTIVE_THREAD_MUTATION', payload)
    },
    SET_CLIENT_ACTIVE_THREAD:({ commit }, payload) => {
      commit('SET_CLIENT_ACTIVE_THREAD_MUTATION', payload)
    },
    SET_GROUP_ACTIVE_THREAD:({ commit }, payload) => {
      commit('SET_GROUP_ACTIVE_THREAD_MUTATION', payload)
    },
    SET_ACTIVE_SINGLE_THREAD_DETAILS: ({ commit }, payload) => {
      commit('SET_ACTIVE_SINGLE_THREAD_DETAILS_MUTATION', payload)
    },
    SET_ACTIVE_TAB: ({ commit }, payload) => {
      commit('SET_ACTIVE_TAB_MUTATION', payload)
    },
    SET_CHATS: ({ commit }, payload) => {
      commit('SET_CHATS_MUTATION', payload)
    }
  },
  getters: {
    ChatRelatedTo:(state) => state.ChatRelatedTo,

    UserThreads:(state) => state.UserThreads,
    ClientThreads:(state) => state.ClientThreads,
    GroupThreads:(state) => state.GroupThreads,


    //----------- Course Related Chats -----------
    UserActiveThread: (state) => state.User_Active_Thread,
    ClientActiveThread: (state) => state.Client_Active_Thread,
    GroupActiveThread: (state) => state.Group_Active_Thread,
    //----------- Course Related Chats -----------


    //----------- Class Related Chats -----------
    UserThreadsClass:(state) => state.UserThreadsClass,
    ClientThreadsClass:(state) => state.ClientThreadsClass,
    GroupThreadsClass:(state) => state.GroupThreads,
    //----------- Class Related Chats -----------


    //----------- General Related Chats -----------
    UserThreadsGeneral:(state) => state.UserThreadsGeneral,
    ClientThreadsGeneral:(state) => state.ClientThreadsGeneral,
    GroupThreadsGeneral:(state) => state.GroupThreadsGeneral,
    //----------- General Related Chats -----------


    SingleActiveThreadDetails: (state) => state.Active_Single_Thread_Details,
    // active_thread:(state) => state.active_thread,
    tabActive:(state) => state.ActiveTab,
    chats:(state) => state.chats
  }
}
export default message

